<div fxLayout="row" fxLayoutAlign="space-between center" class="p-2">
    <div fxLayout="row">
        <mat-button-toggle-group #controls="matButtonToggleGroup" appearance="legacy">            

            <mat-button-toggle value="search">
                <mat-icon>search</mat-icon>
            </mat-button-toggle>           
        </mat-button-toggle-group>            
    </div>
    <form class="user-search" [class.show]="controls.value == 'search'">
        <mat-form-field class="user-search-input">
            <input matInput placeholder="Search Véhicule..." (keyup)="applyFilter($event)" name="search">
        </mat-form-field>
    </form>
</div>
<mat-card class="m-2 p-0">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2" *ngIf="afficheAddcars == true" id="afficheAddcars">
        <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.sm="33">
            
            <button  mat-icon-button  color="primary" matTooltip="Affichage en Grille" (click)="changeViewType('grid')">
                <span><mat-icon>grid_view</mat-icon></span>
            </button>
            <button  mat-icon-button  color="primary" matTooltip="Affichage en Liste" (click)="changeViewType('list')">
                <span><mat-icon>format_list_bulleted</mat-icon></span>
            </button>
           
        </div>
        <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.sm="33"></div>
        <div fxFlex="100" fxFlex.gt-sm="33" fxFlex.sm="33">
            <button mat-raised-button color="primary" routerLink="/compte-utilisateur/mes-vehicules/liste-vehicule">
                <mat-icon>add</mat-icon>
                Proposer un véhicule
            </button>
        </div>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2"  *ngIf="afficheCoordonnees == false" id="afficheCoordonnees">
        <div></div>
        <button mat-raised-button color="warn" routerLink="/compte-utilisateur/mon-compte/mes-coodonnees">
            Adresse incomplet
        </button>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="space-between center" class="w-100 p-2"  *ngIf="affichepermis == false" id="affichepermis">
        <div></div>
        <button mat-raised-button color="warn" routerLink="/compte-utilisateur/mon-compte/permis">
            Permis incomplet
        </button>
    </div>
    
    
    
    <mat-divider></mat-divider>
    <div class="table-wrapper" *ngIf="viewType==='list'"> 
        <table mat-table [dataSource]="dataSource" matSort class="w-100">
        
            <!-- Image Column -->
            <ng-container matColumnDef="image">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
                <td mat-cell *matCellDef="let renting">
                    <div *ngIf="renting.image != null">
                        <img width="60" src={{hostService.getHttpsImage()+renting.image}} class="vehicule">
                    </div>
                </td>
            </ng-container>  

            <!-- Mark et modèle Column -->
            <ng-container matColumnDef="mark">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Véhicule </th>
                <td mat-cell *matCellDef="let renting">{{ renting.vehicle_mark }} {{ renting.vehicle_model }}</td>
            </ng-container> 
    
            <!-- Date Start Column -->
            <ng-container matColumnDef="dateStart">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date départ </th>
                <td mat-cell *matCellDef="let renting">{{ renting.renting_date_departure | date |titlecase}}</td>
            </ng-container>  
            
            <!-- Date End Column -->
            <ng-container matColumnDef="dateEnd">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date retour </th>
                <td mat-cell *matCellDef="let renting">{{renting.renting_date_return| date |titlecase}}</td>
            </ng-container>   

            <!-- Price Column -->
            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Prix </th>
                <td mat-cell *matCellDef="let renting">{{renting.price_to_be_paid}} {{currency}}</td>
            </ng-container> 

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Statut </th>
                <td mat-cell *matCellDef="let renting">
                    <span *ngIf="renting.renting_status == 'EN_ATTENTE'" style="color: blue;">En attente de Validation</span>
                    <span *ngIf="renting.renting_status == 'VALIDER'" style="color: rgb(3, 154, 3);">Validée</span>
                    <span *ngIf="renting.renting_status == 'REJETER'" style="color:crimson;">Rejetée</span>
                    <span *ngIf="renting.renting_status == 'ANNULER'" style="color: red;">Annulée</span>
                    <span *ngIf="renting.renting_status == 'TERMINER'" style="color: rgb(245, 153, 68);">Terminée</span>
                    <span *ngIf="renting.renting_status == 'PAYER'" style="color: rgb(149, 157, 42);">
                        <span *ngIf="renting.renting_date_departure >= currentDate! ; else elseBlock">En Cours</span>
                        <ng-template #elseBlock>Payée</ng-template>
                    </span>
                </td>
            </ng-container> 
            
            <!-- Date Column -->
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
                <td mat-cell *matCellDef="let renting">{{renting.created_at| date:"dd MMMM, yyyy 'a' HH:mm" }}</td>
            </ng-container> 

            <!-- Lodger Column -->
            <!-- <ng-container matColumnDef="lodger">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Locataire </th>
                <td mat-cell *matCellDef="let renting">{{renting.lodger_name}} {{renting.lodger_surname}}</td>
            </ng-container>  -->
    
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let renting">  
                    <button *ngIf="renting.renting_status == 'EN_ATTENTE'" mat-icon-button  color="primary" matTooltip="Valider la location" (click)="changeStatus(renting, 'VALIDER')">
                        <mat-icon>check</mat-icon>
                    </button>
                    <button *ngIf="renting.renting_status == 'EN_ATTENTE'" mat-icon-button  color="warn" matTooltip="Rejeter la location" (click)="changeStatus(renting, 'REJETER')">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <button *ngIf="renting.renting_status == 'PAYER'" mat-icon-button  color="warn" matTooltip="Annuler la location" (click)="changeStatus(renting, 'ANNULER')">
                        <mat-icon>clear</mat-icon>
                    </button>
                    <button (click)="viewRenting(renting.id)" mat-icon-button  color="accent" matTooltip="De plus détails sur la réservation">
                        <mat-icon>visibility</mat-icon>
                    </button>
                    <button *ngIf="renting.renting_status == 'PAYER'" mat-icon-button style="color:#fbc02d;" matTooltip="faire noter la reservation" (click)="noterReservation(renting.id, renting)">
                        <mat-icon>grade</mat-icon>
                    </button>
                </td>
            </ng-container> 
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let renting; columns: displayedColumns;"></tr>
        </table> 
        <p *ngIf="dataSource && dataSource.data.length === 0" class="py-5 mb-0 text-center">Pas de données disponibles</p> 
    </div>


    <div fxLayout="row wrap" fxLayoutAlign="center" class="w-100 p-2" *ngIf="viewType==='grid'">
        <mat-card class="menu-item" [fxLayout]="(viewType == 'grid') ? 'column' : 'row'"
            [ngClass]="[viewType + '-item', 'column-'+column]" fxFlex.gt-sm="30" fxFlex.sm="30"  *ngFor="let item of rentings | paginate: { itemsPerPage: 10, currentPage: p }">
            <div fxFlex="100" [fxShrink]="(viewType == 'grid') ? '3' : '2'" class="thumbnail-section">
                <div *ngIf="lazyLoad">
                    <!-- <img src={{hostService.getHttpsImage()+menuItem.title_image}} class="w-100 d-block swiper-lazy" height="300"> -->
                    <img src={{hostService.getHttpsImage()+item.image}} class="vehicule_2 wiper-lazy">
                </div>
                <!-- <img *ngIf="!lazyLoad" src={{hostService.getHttpsImage()+menuItem.title_image}} class="w-100 d-block" height="300"> -->
                <img *ngIf="!lazyLoad" src={{hostService.getHttpsImage()+item.image}} class="vehicule_2" >
            </div>
            <div fxFlex="100" class="p-3">
                <div fxLayout="column" fxLayoutAlign="start stretch" class="h-100">
                    <mat-card-content class="mb-0">
                        <h1 class="title">{{ item.vehicle_mark }} {{ item.vehicle_model }}</h1>
                        <div>
                            <button class="item-button" mat-flat-button  matTooltip="Nombres de place" color="secondary">{{item.number_place_limit}} <mat-icon>group</mat-icon></button>
                            <button class="item-button" mat-flat-button matTooltip="Moteur" color="secondary">M <mat-icon>account_tree</mat-icon></button>
                            <!-- <button class="item-button" mat-flat-button matTooltip="Energie" color="secondary">D <mat-icon>energy_savings_leaf</mat-icon></button> -->
                            <button class="item-button" mat-flat-button matTooltip="Climatisation" color="secondary">A/C <mat-icon>severe_cold</mat-icon></button>
                        </div>
                        <div>
                            <h1></h1>
                        </div>
                        <div class="mt-2 mb-2"> 
                            <div class="features">
                               
                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">event</mat-icon> Date départ</span>
                                    <span class="dots"></span>
                                    <span class="fw-500">{{ item.renting_date_departure | date |titlecase}}</span>
                                </p>
                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">today</mat-icon> Date retour                                    </span>
                                    <!-- <span class="px-1">Modèle:</span> -->
                                    <span class="dots"></span>
                                    <span class="fw-500">{{item.renting_date_return| date |titlecase}}</span>
                                </p>
                            
                                <p fxLayout="row" fxLayoutAlign="start center end" class="mb-1 desc-car">
                                    <span class="px-1"><mat-icon class="icon-desc">task_alt</mat-icon> Statut</span>
                                    <span class="dots"></span>
                                    <span class="fw-500" *ngIf="item.renting_status == 'EN_ATTENTE'" style="color: blue;">En attente de Validation</span>
                                    <span class="fw-500" *ngIf="item.renting_status == 'VALIDER'" style="color: rgb(3, 154, 3);">Validée</span>
                                    <span class="fw-500" *ngIf="item.renting_status == 'REJETER'" style="color:crimson;">Rejetée</span>
                                    <span class="fw-500" *ngIf="item.renting_status == 'ANNULER'" style="color: red;">Annulée</span>
                                    <span class="fw-500" *ngIf="item.renting_status == 'PAYER'" style="color: rgb(149, 157, 42);">
                                        <span class="fw-500" *ngIf="item.renting_date_departure >= currentDate! ; else elseBlock">En Cours</span>
                                        <ng-template #elseBlock>Payée</ng-template>    
                                    </span>
                                    <span class="fw-500" *ngIf="item.renting_status == 'TERMINER'" style="color: rgb(245, 153, 68);">Terminée</span>
                                </p>
                               
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions class="m-0 p-0">
                        <div fxLayout="row" fxLayoutAlign="space-between center" class="divider mt-1">

                            <h2 class="primary-color">
                                {{ item.vehicle_price_location}} {{appService.getCurrency()}}
                            </h2>

                            <div class="text-muted">
                                <div fxLayout="row" fxLayoutAlign="space-between center" class="divider mt-1">
                                    <button *ngIf="item.renting_status == 'EN_ATTENTE'" mat-icon-button  color="primary" matTooltip="Valider la location" (click)="changeStatus(item, 'VALIDER')">
                                        <mat-icon>check</mat-icon>
                                    </button>
                                    <button *ngIf="item.renting_status == 'EN_ATTENTE'" mat-icon-button  color="warn" matTooltip="Rejeter la location" (click)="changeStatus(item, 'REJETER')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <button *ngIf="item.renting_status == 'PAYER'" mat-icon-button  color="warn" matTooltip="Annuler la location" (click)="changeStatus(item, 'ANNULER')">
                                        <mat-icon>clear</mat-icon>
                                    </button>
                                    <button (click)="viewRenting(item.id)" mat-icon-button  color="accent" matTooltip="De plus détails sur la réservation">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                    <button *ngIf="item.renting_status == 'PAYER'" mat-icon-button style="color:#fbc02d;" matTooltip="faire noter la reservation" (click)="noterReservation(item.id, item)">
                                        <mat-icon>grade</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-card-actions>
                </div>
            </div>
        </mat-card>
            
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="space-between" class="w-100 p-2">
        <div fxFlex="100" fxFlex.gt-sm="20" fxFlex.sm="20">
            <button  mat-icon-button  color="primary" matTooltip="Rafraichir" (click)="refresh()">
                <span><mat-icon>refresh</mat-icon> Mise à jour</span>
            </button>
        </div>
        
        <div fxFlex="100" fxFlex.gt-sm="80" fxFlex.sm="80" *ngIf="viewType==='grid'">
            <pagination-controls (pageChange)="p = $event" style="text-align: end;"></pagination-controls>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 50]" class="{{viewType==='list' ? 'block' : 'hidden'}}" ></mat-paginator>
    </div>
</mat-card>
<ngx-spinner type="ball-clip-rotate-multiple" color="#e91e63" bdColor="rgba(51,51,51,0.8)">
    <p style="font-size: 20px; color: #e91e63; margin-top: 20px; font-weight: bold;">Loading...</p>
</ngx-spinner>